import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefresh = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 14 14",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_refresh)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.91732 5.83293H13.4173V2.33293M13.4173 5.83293L10.7107 3.2896C10.0837 2.66235 9.3081 2.20413 8.45618 1.95771C7.60426 1.7113 6.7038 1.6847 5.83882 1.88041C4.97384 2.07613 4.17253 2.48777 3.50967 3.07692C2.84681 3.66608 2.344 4.41355 2.04815 5.2496M4.08398 8.16626H0.583984V11.6663M0.583984 8.16626L3.29065 10.7096C3.91759 11.3368 4.6932 11.7951 5.54512 12.0415C6.39704 12.2879 7.2975 12.3145 8.16248 12.1188C9.02746 11.9231 9.82877 11.5114 10.4916 10.9223C11.1545 10.3331 11.6573 9.58564 11.9532 8.7496",
			stroke: "currentColor",
			strokeWidth: 1.17,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_refresh",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
export default SvgRefresh;
